module.exports = __webpack_public_path__ + "img/质检与发货.77c7d375.png";